var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFactCheck = function SvgFactCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 776h200v-80H200zm382-80 198-198-57-57-141 142-57-57-56 57zm-382-80h200v-80H200zm0-160h200v-80H200zM80 936V216h800v720zm80-80h640V296H160zm0 0V296z"
  })));
};
export default SvgFactCheck;